import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
const DesktopDevPageSide300x250Atf = /*#__PURE__*/ React.memo(({ safety = 'off', safetyState })=>{
    const _useAdUnit = useAdUnit(AdProviders.Hashtag, ADUNIT_MAP['UserDesktopDevPageSide300x250AtfGam'], safety, safetyState, {
        targeting: {
            unitType: 'atf'
        }
    }), { advertIsOff } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff === 'off') {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", slotAttr);
}, adunitMemo);
DesktopDevPageSide300x250Atf.displayName = 'DesktopDevPageSide300x250Atf';
export default DesktopDevPageSide300x250Atf;
